import { createSelector } from "reselect";

import { State } from "../../model/State";

const getTimeZones = (state: State) => state.timeZones;
export const getTimeZoneSelectModel = createSelector(
    [getTimeZones],
    (timeZones) => {
        if (!timeZones || timeZones.length <= 0) {
            return null;
        }

        let currentTimeZone = "UTC"; // default
        const currentTimeZoneIana = Intl.DateTimeFormat().resolvedOptions().timeZone;
        if (currentTimeZoneIana) {
            const currentTimeZoneEntry = timeZones.find((t) => t.ianaNames && t.ianaNames.indexOf(currentTimeZoneIana) >= 0);
            if (currentTimeZoneEntry) {
                currentTimeZone = currentTimeZoneEntry.id;
            }
        }

        const timeZonesModel = timeZones.map((t) => ({ value: t.id, label: t.label }));
        return {
            currentTimeZone: currentTimeZone,
            timeZones: timeZonesModel
        };
    }
);
